import { useEffect, useState } from 'react'

/**
 * Estado que sobrevive al refresh, guardado en localStorage.
 *
 * Misma implementación que las copias locales de ContactsPage/PoliciesPage/
 * UsersPage/QuotesPage; esas se pueden migrar aquí cuando se toquen.
 */
export function useLocalStorage<T>(key: string, initialValue: T) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key)
      return item ? (JSON.parse(item) as T) : initialValue
    } catch {
      return initialValue
    }
  })

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(storedValue))
    } catch {
      // puede fallar en modo incógnito
    }
  }, [key, storedValue])

  return [storedValue, setStoredValue] as const
}
